import React from "react";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from "@mui/material";
import { TemplateType } from "../../../../../stores/flowsTemplatesStore";
import { useEditTemplateModal, TEMPLATE_TYPES } from "./useEditTemplateModal";
import BaseModal from "../../../../../components/Modal/BaseModal";
import { EditTemplateModalProps } from "./types";

export const EditTemplateModal: React.FC<EditTemplateModalProps> = ({
  open,
  template,
  onClose,
}) => {
  const {
    name,
    templateType,
    loading,
    setName,
    setTemplateType,
    handleSubmit,
    handleClose,
    isSubmitDisabled,
  } = useEditTemplateModal({ template, onClose });

  return (
    <BaseModal
      open={open}
      onClose={handleClose}
      title="Edit Template"
      maxWidth="sm"
      fullWidth
      cancelText="Cancel"
      submitText="Save Changes"
      onSubmit={handleSubmit}
      submitDisabled={isSubmitDisabled}
      submitLoading={loading}
      dataTestId="edit-template-modal"
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <TextField
          fullWidth
          label="Template Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g., Monthly Portfolio Report"
          inputProps={{ "data-testid": "template-name-input" }}
        />

        <FormControl fullWidth>
          <InputLabel>Template Type</InputLabel>
          <Select
            value={templateType}
            label="Template Type"
            onChange={(e) => setTemplateType(e.target.value as TemplateType)}
            data-testid="template-type-select"
          >
            {TEMPLATE_TYPES.map((type) => (
              <MenuItem key={type.value} value={type.value}>
                {type.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </BaseModal>
  );
};
